Vue.asyncComponent('cms-active-workspace', {
    data() {
        return {
            activeWorkspace: this.$userInterfaceHandler.getUserInterface()?.workspace,
            workspaceCount: this.$userInterfaceHandler.getUserInterface()?.workspaceCount,
            lastWorkspaces: this.$userInterfaceHandler.getUserInterface()?.lastWorkspaces,
            workspaceAllRedirectPath: this.$userInterfaceHandler.getUserInterface()?.workspaceAllRedirectPath,
            workspaceAllAccess: this.$userInterfaceHandler.getUserInterface()?.workspaceAllAccess,
            workspacePublicLink: this.$userInterfaceHandler.getUserInterface()?.workspacePublicLink,
            menuWorkspace: this.$userInterfaceHandler.getUserInterface()?.menuWorkspace
        }
    },
    watch: {
        '$userInterfaceHandler.userInterface': {
            handler() {
                this.activeWorkspace = this.$userInterfaceHandler.getUserInterface()?.workspace;
                this.workspaceCount = this.$userInterfaceHandler.getUserInterface()?.workspaceCount;
                this.lastWorkspaces = this.$userInterfaceHandler.getUserInterface()?.lastWorkspaces;
                this.workspacePublicLink = this.$userInterfaceHandler.getUserInterface()?.workspacePublicLink;
                this.workspaceAllRedirectPath = this.$userInterfaceHandler.getUserInterface()?.workspaceAllRedirectPath;
                this.workspaceAllAccess = this.$userInterfaceHandler.getUserInterface()?.workspaceAllAccess;
                this.menuWorkspace = this.$userInterfaceHandler.getUserInterface()?.menuWorkspace;
            }, deep: true
        }
    },
    props: {
        showWorkspacesThreshold: {
            type: Number,
            default: 1
        }
    },
    methods: {
        switchWorkspace(workspaceId) {
            this.$userInterfaceHandler.switchWorkspace(workspaceId);
        }
    }
}, 'cms/layout/cms-active-workspace.html');
